/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * What a Policy Defaults history event records. The first five are company-wide changes made on the Assign Policies page (the "Defaults & exceptions" category); `manualEditMade` and `manualEditRemoved` are one job's policy assignment changed by Override or Reset (the "Job edits" category).
 *
 */
export enum PolicyHistoryKind {
    DEFAULT_CHANGED = 'defaultChanged',
    EXCEPTION_CREATED = 'exceptionCreated',
    EXCEPTION_UPDATED = 'exceptionUpdated',
    EXCEPTION_DELETED = 'exceptionDeleted',
    EXCEPTIONS_REORDERED = 'exceptionsReordered',
    MANUAL_EDIT_MADE = 'manualEditMade',
    MANUAL_EDIT_REMOVED = 'manualEditRemoved',
}
